import { render, staticRenderFns } from "./protocol1.vue?vue&type=template&id=4fd69bc9"
import script from "./protocol1.vue?vue&type=script&lang=js"
export * from "./protocol1.vue?vue&type=script&lang=js"
import style0 from "./protocol1.vue?vue&type=style&index=0&id=4fd69bc9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports